import _ from 'lodash'
import { beforeEnterNeedAdultCheckPage } from '@/common/utils/common'
import {
  PATH_NAME_BAND_VIEW_API,
  PATH_NAME_BAND_VIEW_GNB_CODE,
  PATH_NAME_HOME, PATH_NAME_INSTANT_LIST,
  PATH_NAME_LIST
} from '@/common/resources/router.const'
import { getUrlFromUiCode } from '@/common/utils/request.common'


const listPageBeforeEnter = (to, from, next) => {
  const apiQueryParam = _.get(to, 'query.api', '')
  if (apiQueryParam === '') {
    const uiCode = _.get(to, 'path', '').split('/').pop()
    if (uiCode === undefined || uiCode === '') { next() }
    getUrlFromUiCode(uiCode).then(({ data }) => {
      const orgPath = _.get(to, 'path', '')
      const apiUrl = _.get(data, 'url', '')
      const came = _.get(data, 'query.came', '')
      next({ path: `${orgPath}?api=${encodeURIComponent(apiUrl)}${came === '' ? '&came=home' : ''}`, replace: true })
    })
  } else {
    beforeEnterNeedAdultCheckPage(to, from, next)
  }
}

export default [
  {
    path: 'list/:uiCode',
    name: PATH_NAME_LIST,
    components: {
      bodyContent: () => import(/* webpackChunkName: "viewMoreList" */'@/pages/list')
    },
    props: true,
    beforeEnter: listPageBeforeEnter
  },
  {
    path: 'instantlist/:uiCode',
    name: PATH_NAME_INSTANT_LIST,
    components: {
      bodyContent: () => import(/* webpackChunkName: "instantPlayerList" */'@/pages/list/instantPlayerIndex')
    },
    props: true,
    beforeEnter: listPageBeforeEnter
  },
  {
    path: 'supermultisection/GN9',
    redirect: 'baseball'
  },
  {
    path: 'supermultisection/:uiCode',
    name: PATH_NAME_BAND_VIEW_GNB_CODE,
    components: {
      bodyContent: () => import(/* webpackChunkName: "bandView" */'@/pages/band/indexWithGnbCode')
    },
    props: true
  },
  {
    path: 'supermultisection',
    name: PATH_NAME_BAND_VIEW_API,
    components: {
      bodyContent: () => import(/* webpackChunkName : "superMultiSectionList" */'@/pages/band/indexWithApi')
    },
    beforeEnter (to, from, next) {
      const api = _.get(to, 'query.api', '')
      if (api === '') {
        next({ name: PATH_NAME_HOME })
      } else {
        next()
      }
    }
  }
]
